module.exports = __webpack_public_path__ + "img/bannerxin.0893cb08.svg";